var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"editing-toggle icon",class:{editing: _vm.editing},on:{"click":_vm.toggleEditingMode}},[_c('v-icon',{attrs:{"name":"edit"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }